export default __webpack_public_path__ + "static/media/Flashburst Wristbands.a9c55080.jpg";